export default __webpack_public_path__ + "static/media/mon_24.def6d328.png";